export const PRE_LOADER = {
  event:{
    sceneFadeOut:'scene--fadeOut',
    sceneFadeIn:'scene--fadeIn',
  },
  text: 'Загрузка'
}